import React, { useState, useEffect } from 'react'

const Achievements = ({setLoading}) => {
const [categoryFilter, setCategoryFilter] = useState('All');
  const [achieve, setAchieve] = useState([]);
  const [selectedAch, setSelectedAch] = useState('');
  const [showAch, setShowAch] = useState(false);
  const [showDel, setShowDel] = useState(false);
  const [responseMsg, setResponseMsg] = useState('');
  const [showAdd, setShowAdd] = useState(false);
const [formData, setFormData] = useState({
  tagline: '',
  description: '',
  image: null,
  status: 'Approved',
  added_by: 'School',
    category: 'All',
    batch: ''
})


const handleChange = (e) => {
  const { name, value } = e.target;
  setFormData({ ...formData, [name]: value });
};

const handleImageChange = (e) => {
  const file = e.target.files[0];
  if (file) {
    setFormData({ ...formData, image: file });
  }
};

          useEffect(() => {
              fetchAchievement();
          }, []);


              const fetchAchievement = async () => {
                  setLoading(true);
                  try {
                      const response = await fetch('https://api.kcian.in/get-achievement');
      
                      if (response.ok) {
                          const data = await response.json();
 data.sort((a, b) => new Date(b.date) - new Date(a.date));
 console.log(data);
 setAchieve(data);
                          setLoading(false);
                      } else {
                          setLoading(false);
                          console.error('Failed to fetch coupon');
                      }
                  } catch (error) {
                      setLoading(false);
                      console.error('Error fetching data:', error);
                  }
              };
      
          
const handleSubmit = async (e) => {
  e.preventDefault();

  const payload = new FormData();
  payload.append('tagline', formData.tagline);
  payload.append('description', formData.description);
  payload.append('image', formData.image);
  payload.append('status', formData.status || 'Unapproved');
  payload.append('added_by', formData.added_by);
    payload.append('category', formData.category);
    payload.append('batch', formData.batch);

  setLoading(true);

  try {
    const response = await fetch('https://api.kcian.in/add-achievement', {
      method: 'POST',
      body: payload,
    });

    if (response.ok) {
        setLoading(false);
      setShowAdd(false);
      fetchAchievement();
      setFormData({ tagline: '', description: '', image: null, status: 'Approved', batch: '', added_by: 'School', category: 'All' });
        setResponseMsg('Achievement Added to Academics!');
      setTimeout(() => setResponseMsg(''), 3000);
    } else {
        setLoading(false);      
        setResponseMsg('Something went wrong. Try again later.');
      setTimeout(() => setResponseMsg(''), 2000);
    }
  } catch (error) {
    console.error("Error submitting achievement:", error);
        setLoading(false);
  }
};

  const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    }).replace(',', '');
  };

  
  const handleShowApprove = (ach) => {
    setSelectedAch(ach);
    setShowAch(true);
  }

    const handleShowDel = (ach) => {
    setSelectedAch(ach);
    setShowDel(true);
  }

              const handleApprove = async (achId) => {
    try {
      const response = await fetch(`https://api.kcian.in/approve-post/${achId}`, {
        method: 'PUT',
      });

setLoading(true);

if (response.ok) {
setLoading(false);
        setShowAch(false);
        setResponseMsg('Achievement Approved successfully! Now it will display on Website.');
        setTimeout(() => {
          setResponseMsg('');
        }, 2000);
      } else {
      setResponseMsg('Something Went Wrong. Please try again.');
setLoading(false);
        setTimeout(() => {
          setResponseMsg('');
        }, 2000);  
      }
    } catch (error) {
setLoading(false);
      console.error('Error deleting notice:', error);
    }
  };


              const handleDelete = async (achId) => {
    try {
      const response = await fetch(`https://api.kcian.in/delete-post/${achId}`, {
        method: 'DELETE',
      });


      if (response.ok) {
setAchieve((prevProducts) => prevProducts.filter((ach) => ach.id !== achId));
        setShowDel(false);
        setResponseMsg('Achievement deleted successfully!');
        setTimeout(() => {
          setResponseMsg('');
        }, 2000);
      } else {
      setResponseMsg('Something Went Wrong. Please try again.');
        setTimeout(() => {
          setResponseMsg('');
        }, 2000);  
      }
    } catch (error) {
      console.error('Error deleting notice:', error);
    }
  };

  const handleCategoryFilterChange = (e) => {
  setCategoryFilter(e.target.value);
};


  return (
    <>
      <section className='my-5'>
        <div className='container'>
          <p className='page-heading'>Achievements</p>
          <hr />

          <div className='d-flex justify-content-end'>
<div className="mb-4 text-start me-3">
  <label className="login-label">Select Category:</label>
  <select
    value={categoryFilter}
    onChange={handleCategoryFilterChange}
    className="login-control py-2"
  >
    <option value="All">All</option>
    <option value="Study">Study</option>
  </select>
</div>
            <div className='align-content-center'>
            <button className='notice-btn' onClick={() => setShowAdd(true)}>
              <i className="fa-solid fa-pen-to-square"></i> Add New
            </button></div>
          </div>


                    {responseMsg && (
            <div className='alert alert-success fw-semibold border-0  mt-2'>{responseMsg}</div>
          )}


{showAdd && (
  <>
            <div className='notice-card my-3'>
              <p className='fw-bold'>Add New Achievement</p>


        <form onSubmit={handleSubmit}>

<input type="hidden" name="added_by" value={formData.added_by} />


          <div className='mb-3'>
            <label className='login-label'>Tagline*</label>
            <input
              type='text'
              name='tagline'
              value={formData.tagline}
              onChange={handleChange}
              className='login-control'
              required
            />
          </div>

                              <div className='mb-3'>
            <label className='login-label'>Batch</label>
            <input
              type='text'
              name='batch'
              value={formData.batch}
              placeholder='2024-25'
              onChange={handleChange}
              className='login-control'
            />
          </div>

<div className='mb-3'>
  <label className='login-label'>Category*</label>
  <select
    name='category'
    value={formData.category}
    onChange={handleChange}
    className='login-control'
    required
  >
    <option value='All'>All</option>
    <option value='Study'>Study</option>
  </select>
</div>


          <div className='mb-3'>
            <label className='login-label'>Description*</label>
            <textarea
              name='description'
              value={formData.description}
              onChange={handleChange}
              rows='4'
              className='login-control'
              required
            ></textarea>
          </div>

          <div className='mb-3'>
            <label className='login-label'>Upload Image*</label>
            <input
              type='file'
              accept='image/*'
              onChange={handleImageChange}
              className='login-control'
              required
            />
          </div>

<input type="hidden" name="status" value={formData.status} />

          {formData.image && (
            <div className='mb-3'>
              <img
                src={URL.createObjectURL(formData.image)}
                alt='Preview'
                className='img-fluid rounded border'
                style={{ maxHeight: '160px' }}
              />
            </div>
          )}

                  <button type='submit' className='notice-btn2 me-2'>
                    Submit
                  </button>
                  <button type='button' className='notice-btn2 bg-secondary' onClick={() => setShowAdd(false)}>
                    Cancel
                  </button>

        </form>

      </div>
  </>
)}


              {achieve
  .filter(ach => categoryFilter === 'All' || ach.category === categoryFilter).map(ach => (
                <div className='notice-card my-3'>
<div className='row '>
  <div className='col-lg-4 col-md-4 my-2'>
    <img src={`https://api.kcian.in/uploads/${ach.image}`} className='img-fluid' style={{height: '14em'}} />
    </div>

<div className='col-lg-8 col-md-8 col-12 my-2 align-content-center'>
<p className='fw-bold fm-mont my-0'>{ach.tagline}</p>
  <p className='text-muted para-text'>Posted On: {formatDateTime(ach.posted_on)} by {ach.added_by}<br /> {ach.batch ? <><br />Batch: {ach.batch}</> : null}</p>
  <span className='para-text bg-secondary text-white px-2 py-1 rounded fw-semibold'>Category: {ach.category}</span>
<p className='text-muted fm-mont mt-3'>{ach.description}</p>

{ach.status == 'Unapproved' && <button className='notice-btn me-2' onClick={() => handleShowApprove(ach)} >Approve Now</button>}
<button className='notice-btn' onClick={() => handleShowDel(ach)} >Delete Post</button>
  </div>

</div>
</div>
              ))}



        </div>
      </section>

      {showAch && (
    <>
    <section className='dialog-outer'>
        <div className='dialog-inner col-lg-4 mx-auto text-center py-5'>
            
            <p className='fw-semibold'>Want to Approve '{selectedAch.tagline}'?</p>

                  <button type='submit' className='notice-btn2 me-2' onClick={() => handleApprove(selectedAch.id)}>
                    Yes
                  </button>
                  <button type='button' className='notice-btn2 bg-secondary' onClick={() => setShowAch(false)}>
                    No
                  </button>
        </div>
    </section>
    </>
)}

      {showDel && (
    <>
    <section className='dialog-outer'>
        <div className='dialog-inner col-lg-4 mx-auto text-center py-5'>
            
            <p className='fw-semibold'>Want to Delete '{selectedAch.tagline}'?</p>

                  <button type='submit' className='notice-btn2 me-2' onClick={() => handleDelete(selectedAch.id)}>
                    Yes
                  </button>
                  <button type='button' className='notice-btn2 bg-secondary' onClick={() => setShowDel(false)}>
                    No
                  </button>
        </div>
    </section>
    </>
)}

    </>
  )
}

export default Achievements
